<template>
    <div class="async-loading">
      <p>加载中...</p>
      <!-- 你可以在这里添加更多的加载动画或图标 -->
    </div>
  </template>
  
  <script>
  export default {
    name: 'AsyncLoading'
  }
  </script>
  
  <style scoped scoped>
  .async-loading {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    font-size: 20px;
    color: #333;
  }
  </style>
  